import React from "react";

const ConfirmSection = ({
  departments,
  selectedDept,
  handleDeptChange,
  deptStudents,
  handleRejectAllStudents,
  handleConfirmAllStudents,
  loading
}) => {
  return (
    <div className="confirm-section">
      <h1>Confirm Allotments</h1>
      <div style={{ marginBottom: "20px" }}>
        <label htmlFor="dept-select" style={{ marginRight: "10px" }}>
          Select Department:
        </label>
        <select
          id="dept-select"
          value={selectedDept}
          onChange={handleDeptChange}
          style={{
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ddd",
            minWidth: "200px",
          }}
          disabled={loading}
        >
          <option value="">-- Select Department --</option>
          {departments.map((dept) => (
            <option key={dept.id} value={dept.id}>
              {dept.name}
            </option>
          ))}
        </select>
      </div>
      {selectedDept && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h2>Allotted Students</h2>
            <div>
              <button
                onClick={handleRejectAllStudents}
                disabled={loading || deptStudents.length === 0}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#e74c3c",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginRight: "10px"
                }}
              >
                {loading ? "Processing..." : "Reject All"}
              </button>
              <button
                onClick={handleConfirmAllStudents}
                disabled={loading || deptStudents.length === 0}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#27ae60",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                {loading ? "Processing..." : "Confirm All Students"}
              </button>
            </div>
          </div>
          {deptStudents.length === 0 ? (
            <p>No students found for this department.</p>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f2f2f2" }}>
                    <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>SIP ID</th>
                    <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>Name</th>
                    <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>Project</th>
                    <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>Professor</th>
                    <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {deptStudents.map((project) =>
                    project.selected_students.map((student) => (
                      <tr key={student.sip_id}>
                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                          {student.sip_id}
                        </td>
                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                          {student.name}
                        </td>
                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                          {project.title}
                        </td>
                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                          {project.professor.name}
                        </td>
                        <td style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "center",
                          color: student.admin_conf ? "green" : "red"
                        }}>
                          {student.admin_conf ? "Confirmed" : "Not Confirmed"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ConfirmSection;